import React from "react";
import type { IconProps } from "./types";

export const NewsIcon = React.forwardRef<SVGSVGElement, IconProps>(
  function NewsIcon(
    {
      size = 24,
      width,
      height,
      className = "",
      fill = "currentColor",
      ...props
    },
    ref
  ) {
    return (
      <svg
        ref={ref}
        width={width || size}
        height={height || size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M20 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3ZM4 19V5H11V19H4ZM20 19H13V12H20V19ZM20 10H13V5H20V10Z"
          fill={fill}
        />
      </svg>
    );
  }
);
